import { createContext, useMemo } from 'react';

import { useSelfConnections } from '@frontend/api/hooks/useSelfConnections';

import { BaseConnectionProvider } from './BaseConnectionProvider';
import { ConnectionContextType } from './connectionUtils';

const SelfConnectionContext = createContext<ConnectionContextType>({
  products: {},
});

const SelfConnectionProvider = ({ children }: { children: React.ReactNode }) => {
  const { selfConnectionsQuery } = useSelfConnections();

  const connectionGetter = useMemo(
    () => ({
      connections: selfConnectionsQuery.data || [],
      isPending: selfConnectionsQuery.isPending,
      error: selfConnectionsQuery.error,
    }),
    [selfConnectionsQuery.data, selfConnectionsQuery.isPending, selfConnectionsQuery.error]
  );

  return (
    <BaseConnectionProvider connectionGetter={connectionGetter} context={SelfConnectionContext}>
      {children}
    </BaseConnectionProvider>
  );
};

export { SelfConnectionContext, SelfConnectionProvider };
